import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';

import { useQuery } from '@apollo/client';

import {
  INVOICE_VIEW_QUERY,
  LIST_INVOICE_ACCOUNTINGAREAS_QUERY,
  LIST_INVOICE_COSTCENTRES_QUERY,
} from './gql';

import { RedirectError } from 'pages/error';
import { ProductTextSelector } from 'semshared/pricelist/producttextselector';
import { QuickPriceCalculatorLister } from 'semshared/pricelist/quickprice_lister';
import InvoicePremiumForm from './invoice_premium';
import InvoiceClassicForm from './invoice_classic';
interface InvoiceProps {
  id: number;
}

export default function Invoice(props: InvoiceProps) {
  const offerQuery = useQuery(INVOICE_VIEW_QUERY, {
    variables: { id: props.id },
  });

  const allCostCentresQuery = useQuery(LIST_INVOICE_COSTCENTRES_QUERY, {
    variables: { offerId: props.id, all: true },
  });
  const invoiceCostCentresQuery = useQuery(LIST_INVOICE_COSTCENTRES_QUERY, {
    variables: { offerId: props.id, all: false },
  });
  const allAccountingAreasQuery = useQuery(LIST_INVOICE_ACCOUNTINGAREAS_QUERY, {
    variables: { offerId: props.id, all: true },
  });
  const invoiceAccountingAreasQuery = useQuery(LIST_INVOICE_ACCOUNTINGAREAS_QUERY, {
    variables: { offerId: props.id, all: false },
  });   

  const loading = offerQuery.loading || allCostCentresQuery.loading || invoiceCostCentresQuery.loading || allAccountingAreasQuery.loading || invoiceAccountingAreasQuery.loading;
  const error = offerQuery.error || allCostCentresQuery.error || invoiceCostCentresQuery.error || allAccountingAreasQuery.error || invoiceAccountingAreasQuery.error;

  if (loading) return <CircularProgress />;
  else if (!loading && error) return <RedirectError err={error} />;
  else if (!offerQuery.data?.viewWlOffer || !offerQuery.data?.viewWlOfferInvoiceVersion) return <Navigate to={`/offers`} />;

  const calc = new QuickPriceCalculatorLister();
  calc.hydrate(offerQuery.data!.invoiceQuickPriceDehydrate!);

  const pt = new ProductTextSelector();
  pt.hydrate(offerQuery.data!.invoiceProductTextDehydrate!);

  if (offerQuery.data!.viewWlOffer!.process === 'PREMIUM') {
    return (
      <InvoicePremiumForm
        key={`invoice_${props.id}_${offerQuery.data!.viewWlOfferInvoiceVersion!.updatedAt}`}
        offer={offerQuery.data!.viewWlOffer!}
        version={offerQuery.data!.viewWlOfferInvoiceVersion!}
        downloadVersion={offerQuery.data!.viewWlOfferInvoiceDownloadVersion}
        invoices={offerQuery.data!.viewWlOfferGeneratedInvoices}
        event={offerQuery.data!.viewWlOfferInvoiceEvent}
        quickPriceCalculator={calc}
        productTexts={pt}
        costCentres={allCostCentresQuery.data!.listInvoiceCostCentres}
        accountingAreas={allAccountingAreasQuery.data!.listInvoiceAccountingAreas}
        invoiceCostCentres={invoiceCostCentresQuery.data!.listInvoiceCostCentres}
        invoiceAccountingAreas={invoiceAccountingAreasQuery.data!.listInvoiceAccountingAreas}
      />
    );
  } else {
    return (
      <InvoiceClassicForm
        offer={offerQuery.data!.viewWlOffer!}
        version={offerQuery.data!.viewWlOfferInvoiceVersion!}
        downloadVersion={offerQuery.data!.viewWlOfferInvoiceDownloadVersion}
        event={offerQuery.data!.viewWlOfferInvoiceEvent}
        quickPriceCalculator={calc}
      />
    )
  }
}
